import { Component } from 'react';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import WhileLoopActionDetail from 'automation-ui-action-features/actions/while-loop/WhileLoopActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
class WhileLoopActionHistoryCard extends Component {
  render() {
    const {
      actionMetadata,
      actionLabel
    } = this.props;
    return /*#__PURE__*/_jsx(LogEventRowAction, {
      title: actionLabel,
      content: /*#__PURE__*/_jsx(WhileLoopActionDetail, {
        actionMetadata: actionMetadata
      })
    });
  }
}
export default WhileLoopActionHistoryCard;